const energySections = {
    content: { key: 'dashboard', name: '{{lang}}dashboard', img: '/images/icons/layout.png' },

    froum: { key: 'settings', name: '{{lang}}basic Settings', img: '/images/icons/settings.png' },

    // admin: { key: 'report', name: 'گزارش درخواست ها', img: '/images/icons/file.png' },

    categories: { key: 'operation', name: '{{lang}}operation', img: '/images/icons/computer.png' },

}

const energyPages = {

    dashboard: {
        key: "dashboard",
        title: 'داشبورد',
        description: '',
        // fetchUrl: 'getLogs',
        // addUrl: 'addEmployee',
        // editUrl: 'addEmployee',
        // removeUrl: 'removeEmployee',
        // pageType: 'chartDashboard',
        page: '',
        parent: 'dashboard',
        postBody: {},
        addNew: -1,
        options: { noAddNew: true },
        actions: {
            edit: { key: "edit", label: '{{lang}}view', color: '#F87C56', function: "openEditModal", permission: 'view' },
        },
        // tabs: [
        //     { title: 'Admins', filter: { "role": 'admin' } },
        //     { title: 'Users', filter: { "role": 'user' } },

        // ],

        image: '/images/icons/log.png',
        headers: [

        ],
    },
    managementOfEnergyCarriers: {
        key: 'managementOfEnergyCarriers',
        title: '{{lang}}مدیریت حامل های انرژی',
        description: 'مدیریت حامل های انرژی',
        fetchUrl: 'getEnergyCarriers',
        addUrl: 'postEnergyCarriers',
        editUrl: 'postEnergyCarriers',
        removeUrl: 'removeEnergyCarriers',
        options: { noAddNew: true },
        // actions: {
        //     edit: { key: "edit", label: '{{lang}}مجوز ویرایش درخواست', color: '#F87C56', function: "openEditModal" },
        //     remove: { key: "remove", label: 'حذف', color: '#e96363', function: 'openRemoveModal'},
        //     priceRegistration: { key: "priceRegistration", label: '{{lang}}ثبت بهای حامل', color: '#F87C56', function: "CarrierPriceRegistration" },
        //     done: { key: "done", label: '{{lang}}خاتمه درخواست در صورت رد کردن', color: '#F87C56', function: "" },
        //     notification: { key: "notification", label: '{{lang}}مجوز ارسال جهت اطلاع', color: '#F87C56', function: "" },
        //     attachment: { key: "attachment", label: '{{lang}}مجوز اصلاق پیوست', color: '#F87C56', function: "" },
        //     effectOfChange: { key: "effectOfChange", label: '{{lang}}مجوز تعیین اثر تغییر بر مدرک مرتبط', color: '#F87C56', function: "" },
        //     consultation: { key: "consultation", label: '{{lang}}مجوز دربافت مشورت', color: '#F87C56', function: "" },
        // },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'settings',
        // options: {},
        // sort: { 'cDate': -1 },
        // addNew: '/energy/mydocumentsInfo',
        image: '/images/icons/folder.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'title', type: 'TextInput', information: { label: 'عنوان', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'unit', type: 'TextInput', information: { label: 'واحد اندازه گیری', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'annualConsumption', type: 'NumberInput', information: { label: 'میزان مصرف سالانه', disabled: false, required: false, generateId: true, }, showMain: true, inExport: true },
            { col: '6', key: 'conversionFactor', type: 'NumberInput', information: { label: 'ضریب تبدیل', disabled: false, required: false, generateId: true, }, showMain: true, inExport: true },
            { col: '6', key: 'price', type: 'NumberInput', information: { label: 'بها(ریال)', disabled: false, required: false, generateId: true, }, showMain: true, inExport: true },
            { col: '6', key: 'annualConsumptionGJ', type: 'NumberInput', information: { label: 'مصرف سالانه(گیگاژول)', disabled: false, required: false, generateId: true, }, showMain: true, inExport: true },
        ],

    },
    // mydocumentsInfo: {
    //     key: 'mydocumentsInfo',
    //     title: '{{lang}}My Documents',
    //     description: 'My Documents list',
    //     fetchUrl: 'getOneDocument',
    //     // addUrl: 'categoryAdd',
    //     // editUrl: 'categoryAdd',
    //     // removeUrl: 'removeCategory',
    //     // parentSection: 'mydocuments',

    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}مجوز ویرایش درخواست', color: '#F87C56', function: "openEditModal" },
    //         mandatory: { key: "mandatory", label: '{{lang}}اجباری بودن تایید مشورت دهندگان جهت تایید', color: '#F87C56', function: "" },
    //         done: { key: "done", label: '{{lang}}خاتمه درخواست در صورت رد کردن', color: '#F87C56', function: "" },
    //         review: { key: "review", label: '{{lang}}مجوز ارسال به مرحله قبل جهت بازبینی', color: '#F87C56', function: "" },
    //         notification: { key: "notification", label: '{{lang}}مجوز ارسال جهت اطلاع', color: '#F87C56', function: "" },
    //         attachment: { key: "attachment", label: '{{lang}}مجوز اصلاق پیوست', color: '#F87C56', function: "" },
    //         effectOfChange: { key: "effectOfChange", label: '{{lang}}مجوز تعیین اثر تغییر بر مدرک مرتبط', color: '#F87C56', function: "" },
    //         consultation: { key: "consultation", label: '{{lang}}مجوز دربافت مشورت', color: '#F87C56', function: "" },
    //     },
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     pageType: 'AdminSectionFormApplet',
    //     parent: 'cartable',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     addNew: -1,
    //     hidePage: true,
    //     image: '/images/icons/folder.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     sections: [
    //         {
    //             title: "{{lang}}مدرک", key: 'document',
    //             headers: [
    //                 { col: '6', key: 'name', type: 'TextInput', information: { label: 'عنوان درخواست', disabled: false, required: true }, showMain: true, inExport: true },
    //                 { col: '6', key: 'documentGroup', type: 'SelectInput', information: { label: 'گروه مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
    //                 { col: '6', key: 'documentType', type: 'SelectInput', information: { label: 'نوع مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentType', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
    //                 { col: '6', key: 'description', type: 'TextInput', information: { label: 'توضیحات', disabled: false, required: false }, showMain: true, inExport: true },
    //                 { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
    //                 { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
    //             ]
    //         },
    //     ],
    //     headers: [
    //         { col: '6', type: 'SelectInput', key: 'initStatus', information: { label: 'وضعیت', type: 'local', items: [{ value: 'submit', title: 'تایید' }, { value: 'reject', title: 'رد' }, { value: 'edit', title: 'نیاز به اصلاح' }], isSearchable: true, placeholder: 'انتخاب وضعیت', required: true }, showMain: true },

    //         // { col: '6', key: 'documentGroup', type: 'SelectInput', information: { label: 'گروه مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: true },
    //         // { col: '6', key: 'documentType', type: 'SelectInput', information: { label: 'نوع مدارک', updateAfterSelect: true, isSearchable: false, address: 'getDocumentType', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: true },
    //         // { col: '6', key: 'description', type: 'TextInput', information: { label: 'توضیحات', disabled: false, required: false }, showMain: true, inExport: true },
    //         // { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
    //         // { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: true },
    //     ],

    // },

    listOfEnergyUses: {
        key: 'listOfEnergyUses',
        title: '{{lang}}فهرست کاربری‌های انرژی',
        description: 'فهرست کاربری‌های انرژی',
        fetchUrl: 'getListOfEnergyUses',
        addUrl: 'postListOfEnergyUses',
        editUrl: 'postListOfEnergyUses',
        removeUrl: 'removeListOfEnergyUses',
        // options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'settings',
        // options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        // addNew: '/admin/recordInfo',
        image: '/images/icons/folder.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'title', type: 'TextInput', information: { label: 'نام کاربری', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'technicalCode', type: 'TextInput', information: { label: 'کد فنی', disabled: false, required: false, generateId: true, }, showMain: true, inExport: true },
            { col: '6', type: 'SelectInput', key: 'type', information: { label: 'نوع', type: 'local', items: [{ value: 'energy', title: 'مرز انرژی' }, { value: 'user', title: 'کاربری' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'والد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getJobs', filter: {} }, settings: { required: true }, showMain: true },
        ],

    },

    // recordInfo: {
    //     key: 'recordInfo',
    //     title: '{{lang}}My Records',
    //     description: 'My Records list',
    //     fetchUrl: 'getOneMyRecord',
    //     // addUrl: 'categoryAdd',
    //     // editUrl: 'categoryAdd',
    //     // removeUrl: 'removeCategory',
    //     // options: { noAddNew: true },
    //     // helperKey: 'values',
    //     pageType: 'AdminSectionFormApplet',
    //     parent: 'cartable',
    //     // options: {},
    //     hidePage: true,
    //     // sort: { 'cDate': -1 },
    //     addNew: -1,
    //     image: '/images/icons/folder.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     sections: [
    //         {
    //             title: "{{lang}}سابقه", key: 'record',
    //             headers: [
    //                 { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //                 { col: '6', key: 'recordGroup', type: 'SelectInput', information: { label: 'گروه سوابق', updateAfterSelect: true, isSearchable: false, address: 'getRecordsGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
    //                 { col: '6', key: 'validityDate', type: 'DateInput', information: { label: 'تاریخ اعتبار', disabled: false, required: true }, showMain: true, inExport: true },
    //                 { col: '6', key: 'recordDate', type: 'DateInput', information: { label: 'تاریخ سابقه', disabled: false, required: true }, showMain: true, inExport: true },
    //                 { col: '6', key: 'reviewPeriod', type: 'NumberInput', information: { label: 'دوره بازنگری', disabled: false, required: true }, showMain: true, inExport: true },
    //                 { col: '6', type: 'SelectInput', key: 'repetitionPeriod', information: { label: 'مدت تکرار', type: 'local', items: [{ value: 'day', title: 'یک روز' }, { value: 'week', title: 'یک هفته' }, { value: 'Month', title: 'یک ماه' }, { value: 'Year', title: 'یک سال' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
    //                 { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
    //                 { col: '6', key: 'secondCode', type: 'TextInput', information: { label: 'کد دوم مدرک', disabled: false, required: true }, showMain: true, inExport: true },
    //                 { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
    //             ]
    //         },
    //     ],
    //     headers: [
    //         // { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         // { col: '6', key: 'recordGroup', type: 'SelectInput', information: { label: 'گروه سوابق', updateAfterSelect: true, isSearchable: false, address: 'getRecordsGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select...', required: false }, showMain: false },
    //         // { col: '6', key: 'validityDate', type: 'DateInput', information: { label: 'تاریخ اعتبار', disabled: false, required: true }, showMain: true, inExport: true },
    //         // { col: '6', key: 'recordDate', type: 'DateInput', information: { label: 'تاریخ سابقه', disabled: false, required: true }, showMain: true, inExport: true },
    //         // { col: '6', key: 'reviewPeriod', type: 'NumberInput', information: { label: 'دوره بازنگری', disabled: false, required: true }, showMain: true, inExport: true },
    //         // { col: '6', type: 'SelectInput', key: 'repetitionPeriod', information: { label: 'مدت تکرار', type: 'local', items: [{ value: 'day', title: 'یک روز' }, { value: 'week', title: 'یک هفته' }, { value: 'Month', title: 'یک ماه' }, { value: 'Year', title: 'یک سال' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
    //         // { col: '6', key: 'code', type: 'TextInput', information: { label: 'کد', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
    //         // { col: '6', key: 'secondCode', type: 'TextInput', information: { label: 'کد دوم مدرک', disabled: false, required: true }, showMain: true, inExport: true },
    //         // { col: '12', key: 'files', type: 'FileInput', information: { label: 'files ', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
    //     ],

    // },

    managementOfEvaluationParameters: {
        key: 'managementOfEvaluationParameters',
        title: '{{lang}}مدیریت پارامترهای ارزیابی',
        description: 'مدیریت پارامترهای ارزیابی',
        fetchUrl: 'getEvaluationParameters',
        addUrl: 'postEvaluationParameters',
        editUrl: 'postEvaluationParameters',
        removeUrl: 'removeEvaluationParameters',
        options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'settings',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/doc.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            // {
            //     type: 'SubformInput',
            //     key: 'evaluationParameters',
            //     col: '12',
            //     information: {
            //         headers: [
            //             { col: '6', key: 'title', type: 'TextInput', information: { label: 'عنوان پارامتر', disabled: false, required: true }, showMain: true, inExport: true },
            //             { col: '6', key: 'degreeImportance', type: 'NumberInput', information: { label: 'درجه اهمیت', disabled: false, required: true }, showMain: true, inExport: true },
            //         ],
            //         generateId: true,
            //         placeholder: '{{lang}}placeholders.insertInformation',
            //         required: true,
            //     },
            //     showMain: true
            // },
            { col: '6', key: 'title', type: 'TextInput', information: { label: 'پارامترها', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'degreeImportance', type: 'NumberInput', information: { label: 'درجه اهمیت', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'cDate', type: 'DateInput', information: { label: '{{lang}}تاریخ تعریف', placeholder: '{{lang}}تاریخ تعریف', required: false, disabled: true }, showMain: true },
        ],

    },
    managementOfEffectiveFactors: {
        key: 'managementOfEffectiveFactors',
        title: '{{lang}}مدیریت عوامل موثر',
        description: 'مدیریت عوامل موثر',
        fetchUrl: 'getEffectiveFactors',
        addUrl: 'postEffectiveFactors',
        editUrl: 'postEffectiveFactors',
        removeUrl: 'removeEffectiveFactors',
        options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'settings',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/userdoc.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'title', type: 'TextInput', information: { label: 'عنوان', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'category', type: 'TextInput', information: { label: 'دسته بندی', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'upperLimit', type: 'NumberInput', information: { label: 'حد بالای متغیر', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'lowerLimit', type: 'NumberInput', information: { label: 'حد پایین', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'typeOfAffectiveAgent', type: 'TextInput', information: { label: 'نوع عامل موثر', required: true }, showMain: true },
            { col: '6', key: 'unit', type: 'TextInput', information: { label: 'واحد', required: true }, showMain: true },
            { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
            { col: '6', key: 'lastDataDate', type: 'DateInput', information: { label: 'تاریخ آخرین داده', required: true }, showMain: true },
        ],
    },


    panagingPublicVariables: {
        key: 'panagingPublicVariables',
        title: 'مدیریت متغیرهای عمومی',
        description: 'مدیریت متغیرهای عمومی',
        fetchUrl: 'getPublicVariable',
        addUrl: 'postPublicVariable',
        editUrl: 'postPublicVariable',
        removeUrl: 'removePublicVariable',
        options: { noAddNew: true },
        // helperKey: 'values',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
            // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
            // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        pageType: 'form',
        parent: 'settings',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/orgchart.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'title', type: 'TextInput', information: { label: 'نام متغییر عمومی', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'technicalCode', type: 'TextInput', information: { label: 'کد فنی', disabled: false, required: false, generateId: true, }, showMain: true, inExport: true },
            { col: '6', key: 'unit', type: 'TextInput', information: { label: 'واحد', required: true }, showMain: true },
            { type: 'SelectInput', key: 'category', col: '6', information: { label: 'والد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getChart', filter: {} }, settings: { required: true }, showMain: true },

            // { col: '6', key: 'category', type: 'TextInput', information: { label: 'دسته بندی', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
            { col: '6', type: 'SelectInput', key: 'type', information: { label: 'نوع', type: 'local', items: [{ value: 'total', title: 'مجموع' }, { value: 'average', title: 'میانگین' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'والد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getChart', filter: {} }, settings: { required: true }, showMain: true },
        ],

    },

    managementOfMeters: {
        key: 'managementOfMeters',
        title: '{{lang}}Management of meters',
        description: '{{lang}}Management of meters',
        fetchUrl: 'getJobs',
        addUrl: 'postJobs',
        editUrl: 'postJobs',
        removeUrl: 'removeJobs',
        options: { noAddNew: true },
        // helperKey: 'values',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
            // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
            // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        pageType: 'tree',
        parent: 'settings',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/job.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { type: 'SelectInput', key: 'energyCarrier', col: '6', information: { label: 'حامل انرژی', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getJobs', filter: {} }, settings: { required: true }, showMain: true },
            { col: '6', key: 'title', type: 'TextInput', information: { label: 'نام متغییر عمومی', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', type: 'SelectInput', key: 'type', information: { label: 'نوع', type: 'local', items: [{ value: 'virtual', title: 'مجازی' }, { value: 'real', title: 'واقعی' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { type: 'SelectInput', key: 'userToCarrier', col: '6', information: { label: 'کاربری به حامل', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getJobs', filter: {} }, settings: { required: true }, showMain: true },
            { col: '6', key: 'category', type: 'TextInput', information: { label: 'دسته بندی', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'calibrationPeriod', type: 'TextInput', information: { label: 'دوره کالیبراسیون', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'unit', type: 'TextInput', information: { label: 'واحد', required: true }, showMain: true },
            { col: '6', key: 'technicalCode', type: 'TextInput', information: { label: 'کد فنی', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
            { col: '6', type: 'SelectInput', key: 'status', information: { label: 'نوع', type: 'local', items: [{ value: 'active', title: 'فعال' }, { value: 'Inactive', title: 'غیرفعال' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { col: '6', key: 'lastDataDate', type: 'DateInput', information: { label: 'تاریخ آخرین داده', required: true }, showMain: true },
            { col: '6', key: 'lastCalibration', type: 'TextInput', information: { label: 'آخرین کالیبراسیون', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'nextCalibration', type: 'TextInput', information: { label: 'کالیبراسیون بعدی', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
        ],

    },

    baselineCalculation: {
        key: 'baselineCalculation',
        title: 'محاسبه خط مبنا',
        description: 'فهرست کاربری / حامل‌های بارز (SEU) - محاسبه خط مبن',
        fetchUrl: 'employeeGetAll',
        addUrl: 'employeeAdd',
        editUrl: 'employeeAdd',
        removeUrl: 'employeeRemove',
        options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'operation',
        options: {},
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
            block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
            terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/users.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { type: 'SelectInput', key: 'energyCarrier', col: '6', information: { label: 'حامل انرژی', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getJobs', filter: {} }, settings: { required: true }, showMain: true },
            { type: 'SelectInput', key: 'userToCarrier', col: '6', information: { label: 'کاربری به حامل', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getJobs', filter: {} }, settings: { required: true }, showMain: true },
            { col: '6', key: 'beginningOfTheCalculationPeriod', type: 'DateInput', information: { label: 'ابتدای دوره محاسبه', required: true }, showMain: true },
            { col: '6', key: 'endOfTheCalculationPeriod', type: 'DateInput', information: { label: 'انتهای دوره محاسبه', required: true }, showMain: true },
        ],

    },

    // organizationalChartManagement: {
    //     key: 'organizationalChartManagement',
    //     title: 'مدیریت چارت سازمانی',
    //     description: 'مدیریت چارت سازمانی',
    //     fetchUrl: 'getEnergyChart',
    //     addUrl: 'postEnergyChart',
    //     editUrl: 'postEnergyChart',
    //     removeUrl: 'removeEnergyChart',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     pageType: 'form',
    //     parent: 'whthoutParent',
    //     options: {},
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/process.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [

    //         { col: '6', key: 'title', type: 'TextInput', information: { label: 'نام پست', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'technicalCode', type: 'TextInput', information: { label: 'کد فنی', disabled: false, required: false }, showMain: true, inExport: true },
    //         { col: '6', key: 'organizationalUnit', type: 'TextInput', information: { label: 'واحد سازمانی', disabled: false, required: true }, showMain: true, inExport: true },
    //         { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'والد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getEnergyChart', filter: {} }, settings: { required: true }, showMain: true },
    //     ],

    // },
    managementOfEnergyIndicators: {
        key: 'managementOfEnergyIndicators',
        title: 'مدیریت شاخص‌ های انرژی',
        description: 'مدیریت شاخص‌ های انرژی',
        fetchUrl: 'getEnergyIndicators',
        addUrl: 'postEnergyIndicators',
        editUrl: 'postEnergyIndicators',
        removeUrl: 'removeEnergyIndicators',
        options: { noAddNew: true },
        // helperKey: 'values',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
            // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
            // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        pageType: 'form',
        parent: 'settings',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/list.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', type: 'SelectInput', key: 'status', information: { label: 'نوع', type: 'local', items: [{ value: true, title: 'فعال' }, { value: false, title: 'غیرفعال' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { col: '6', key: 'title', type: 'TextInput', information: { label: 'نام شاخص', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'unit', type: 'TextInput', information: { label: 'واحد', required: true }, showMain: true },
            { col: '6', key: 'upperLimit', type: 'NumberInput', information: { label: 'حد بالا', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'lowerLimit', type: 'NumberInput', information: { label: 'حد پایین', disabled: false, required: false }, showMain: true, inExport: true },
            { type: 'SelectInput', key: 'counterAbove', col: '12', information: { label: 'کد کنتور بالا', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDistributionList', filter: {}, required: false }, settings: { required: false }, showMain: true },
            { col: '12', key: 'highConstantValue', type: 'NumberInput', information: { label: 'مقدار ثابت بالا', placeholder: 'در صورت عدم انتخاب کنتور بالا از مقدار یک استفاده میشود.', disabled: true, required: false }, showMain: true, inExport: true },
            { type: 'SelectInput', key: 'lowMeter', col: '12', information: { label: 'کد کنتور پائین', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDistributionList', filter: {}, required: false }, settings: { required: false }, showMain: true },
            { col: '12', key: 'lowFixedValue', type: 'NumberInput', information: { label: 'مقدار ثابت پایین', placeholder: 'در صورت عدم انتخاب کنتور بالا از مقدار یک استفاده میشود.', disabled: true, required: false }, showMain: true, inExport: true },
            { type: 'NumberInput', key: 'monitoringTimePeriod', col: '6', information: { label: 'دوره زمانی پایش', filter: {}, required: false }, showMain: false },
            { type: 'MultiSelectInput', key: 'referenceMeters', col: '6', information: { label: 'کنتورهای مرجع', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDistributionList', filter: {}, required: false }, settings: { required: false }, showMain: true },
        ],

    },
    operationsControlManagement: {
        key: 'operationsControlManagement',
        title: '{{lang}}Operations control management',
        description: '{{lang}}Operations control management',
        fetchUrl: 'getOperationControl',
        addUrl: 'postOperationControl',
        editUrl: 'postOperationControl',
        removeUrl: 'removeOperationControl',
        options: { noAddNew: true },
        // helperKey: 'values',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
            // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
            // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        pageType: 'form',
        parent: 'operation',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/planning.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { type: 'SelectInput', key: 'operationControl', col: '6', information: { label: 'کنترل عملیات', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getOperationControl', filter: {}, required: false }, settings: { required: false }, showMain: true },
            { type: 'SelectInput', key: 'chartEnergy', col: '6', information: { label: 'مسئول', type: 'api', fields: { value: '_id', title: 'title' }, address: 'getEnergyChart', filter: {}, required: false }, settings: { required: false }, showMain: true },
            { type: 'SelectInput', key: 'EnergyUses', col: '6', information: { label: 'کاربری انرژی', type: 'api', fields: { value: '_id', title: 'title' }, address: 'getListOfEnergyUses', filter: {}, required: false }, settings: { required: false }, showMain: true },
            { type: 'SelectInput', key: 'EnergyCarriers', col: '6', information: { label: 'حامل انرژی', type: 'api', fields: { value: '_id', title: 'title' }, address: 'getEnergyCarriers', filter: {}, required: false }, settings: { required: false }, showMain: true },
            { col: '6', key: 'measuringTool', type: 'TextInput', information: { label: 'ابزار اندازه گیری', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', type: 'SelectInput', key: 'monitoringPeriod', information: { label: 'دوره پایش', type: 'local', items: [{ value: 'daily', title: 'روزانه' }, { value: 'weekly', title: 'هفتگی' }, { value: 'monthly', title: 'ماهانه' }, { value: 'trimester', title: 'سه ماهه' }, { value: 'sixMonths', title: 'شش ماهه' }, { value: 'yearly', title: 'سالانه' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { col: '6', key: 'placeOfRegistration', type: 'TextInput', information: { label: 'محل ثبت', disabled: true, required: false }, showMain: true, inExport: true },

        ],

    },
    productManagement: {
        key: 'productManagement',
        title: 'مدیریت محصولات',
        description: 'مدیریت محصولات',
        fetchUrl: 'getEnergyProducts',
        addUrl: 'postEnergyProducts',
        editUrl: 'postEnergyProducts',
        removeUrl: 'removeEnergyProducts',
        options: { noAddNew: true },
        // helperKey: 'values',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        pageType: 'form',
        parent: 'operation',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/documents.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'title', type: 'TextInput', information: { label: 'نام محصول', disabled: false, required: true }, showMain: true, inExport: true },
            { type: 'SelectInput', key: 'production', col: '6', information: { label: 'کنتور تولید', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDocumentGroup', filter: {} }, settings: { required: true }, showMain: true },
            { type: 'SelectInput', key: 'consumption', col: '6', information: { label: 'کنتور مصرف', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDocumentGroup', filter: {} }, settings: { required: true }, showMain: true },
            { type: 'SelectInput', key: 'carrierCode', col: '6', information: { label: 'کد حامل', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDocumentGroup', filter: {} }, settings: { required: true }, showMain: true },
            { col: '6', key: 'consumptionFactor', type: 'NumberInput', information: { label: 'ضريب مصرف', disabled: false, required: true }, showMain: true, inExport: true },

        ],

    },


    manageImprovementOpportunities: {
        key: 'manageImprovementOpportunities',
        title: 'مدیریت فرصت های بهبود',
        description: 'مدیریت فرصت های بهبود',
        fetchUrl: 'getOpportunitiesImprovement',
        addUrl: 'postOpportunitiesImprovement',
        editUrl: 'postOpportunitiesImprovement',
        removeUrl: 'removeOpportunitiesImprovement',
        options: { noAddNew: true },
        // helperKey: 'values',
        actions: {
            // edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
            // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
            // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        pageType: 'form',
        parent: 'operation',
        // options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/documenttype.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'title', type: 'TextInput', information: { label: 'عنوان', disabled: false, required: true }, showMain: true, inExport: true },
            { type: 'SelectInput', key: 'seu', col: '6', information: { label: 'seu', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDistributionList', filter: {}, required: false }, settings: { required: false }, showMain: true },
            { col: '6', type: 'SelectInput', key: 'priority', information: { label: 'اولویت', type: 'local', items: [{ value: '1', title: '1' }, { value: '2', title: '2' }, { value: '3', title: '3' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { col: '6', key: 'start', type: 'DateInput', information: { label: 'شروع', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'end', type: 'DateInput', information: { label: 'پایان', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', type: 'SelectInput', key: 'references', information: { label: 'منابع', type: 'local', items: [{ value: 'equipment', title: 'تجهیزات' }, { value: 'manpower', title: 'نیروی انسانی' }, { value: 'money', title: 'پول' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { type: 'SelectInput', key: 'responsible', col: '6', information: { label: 'مسئول', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getDistributionList', filter: {}, required: false }, settings: { required: false }, showMain: true },
            { col: '6', key: 'period', type: 'TextInput', information: { label: 'دوره زمانی', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'development', type: 'NumberInput', information: { label: 'پیشرفت', disabled: false, required: true }, showMain: true, inExport: true },
        ],

    },

    standardClause: {
        key: "standardClause",
        title: 'بند استاندارد',
        description: 'بند استاندارد',
        fetchUrl: 'getStandardClause',
        addUrl: 'postStandardClause',
        editUrl: 'postStandardClause',
        removeUrl: 'removeStandardClause',
        pageType: 'form',
        // page: 'partners',
        parent: 'operation',
        // addNew: -1,
        options: { noAddNew: true },

        image: '/images/covers/1.jpg',
        headers: [
            { type: 'TextInput', col: '6', key: 'title', information: { label: 'عنوان', }, showMain: true },
            { type: 'SelectInput', key: 'parent', col: '6', information: { label: 'بند استاندارد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getStandardClause', filter: {} }, settings: { required: true }, showMain: false },
        ],
    },

    documentManagement: {
        key: "documentManagement",
        title: 'مدیریت مدارک و مستندات',
        description: 'مدیریت مدارک و مستندات',
        fetchUrl: 'getDocumentsPapers',
        addUrl: 'postDocumentsPapers',
        editUrl: 'postDocumentsPapers',
        removeUrl: 'removeDocumentsPapers',
        pageType: 'form',
        // page: 'partners',
        parent: 'operation',
        // addNew: -1,
        options: { noAddNew: true },

        image: '/images/covers/1.jpg',
        headers: [
            { col: '6', type: 'SelectInput', key: 'status', information: { label: 'وضعیت', type: 'local', items: [{ value: 'draft', title: 'پیشنویس' }, { value: 'current', title: 'جاری' }, { value: 'finished', title: 'پایان یافته' }, { value: 'canceled', title: 'ملغی' }, { value: 'suspended', title: 'معلق' }], isSearchable: true, placeholder: 'انتخاب کنید', required: true }, showMain: true },
            { type: 'TextInput', col: '6', key: 'title', information: { label: 'عنوان', }, showMain: true },
            { type: 'SelectInput', key: 'standardClause', col: '6', information: { label: 'بند استاندارد', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getStandardClause', filter: {} }, settings: { required: true }, showMain: false },
            { col: '12', key: 'documents', type: 'FileInput', information: { label: 'مستندات', disabled: true, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'cDate', type: 'DateInput', information: { label: 'تاریخ ثبت', disabled: true, required: false }, showMain: true, inExport: true },
        ],
    },

    costAnalysisReport: {
        key: 'costAnalysisReport',
        title: 'گزارش تحلیل مصارف',
        description: 'گزارش تحلیل مصارف',
        fetchUrl: 'getResponsibilities',
        addUrl: 'postResponsibilities',
        editUrl: 'postResponsibilities',
        removeUrl: 'removeResponsibilities',
        options: { noAddNew: true },
        // helperKey: 'values',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
            // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
            // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        pageType: 'form',
        parent: 'operation',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/profile.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'year', type: 'NumberInput', information: { label: 'سال', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'month', type: 'NumberInput', information: { label: 'ماه', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'actualProductionOfThePreviousYear', type: 'NumberInput', information: { label: 'تولید واقعی سال قبل (-)', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'actualConsumptionOfThePreviousYear', type: 'NumberInput', information: { label: 'مصرف واقعی سال قبل (m3)', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'carrierFeeInThePreviousYear', type: 'NumberInput', information: { label: 'هزینه حامل در سال قبل', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'programmaticProduction', type: 'NumberInput', information: { label: 'تولید برنامه‌ای (-)', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'forecastConsumption', type: 'NumberInput', information: { label: 'مصرف پیشبینی (-)', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'predictedPrice', type: 'NumberInput', information: { label: 'بهای پیشبینی', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'actualProduction', type: 'NumberInput', information: { label: 'تولید واقعی (-)', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'actualConsumption', type: 'NumberInput', information: { label: 'مصرف واقعی (-)', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'actualCost', type: 'NumberInput', information: { label: 'هزینه واقعی', disabled: false, required: true }, showMain: true, inExport: true },

        ],

    },


    energyReviewReport: {
        key: 'energyReviewReport',
        title: 'گزارش بازنگری انرژی',
        description: 'گزارش بازنگری انرژی',
        fetchUrl: 'getAllCategory',
        addUrl: 'categoryAdd',
        editUrl: 'categoryAdd',
        removeUrl: 'removeCategory',
        options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'operation',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/database.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { key: 'image', type: 'ImageInput', col: '12', information: { label: '{{lang}}Image', single: true, cropper: true, ratio: '1:1', placeholder: '{{lang}}chooseImage', required: true }, showMain: true },
            { col: '6', key: 'type', type: 'TextInput', information: { label: '{{lang}}Type', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'priority', type: 'NumberInput', information: { label: '{{lang}}priority', disabled: false, required: false }, showMain: true, inExport: true },
            // { col: '6', type: 'MultiSelectInput', key: 'types', information: { label: '{{lang}}section', updateAfterSelect: true, isSearchable: false, address: 'getTypes', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertTypes', required: false }, showMain: false },
            // { col: '6', type: 'MultiSelectInput', key: 'series', information: { label: '{{lang}}series', updateAfterSelect: true, isSearchable: false, address: 'getSeries', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}placeholders.insertSeries', required: false }, showMain: false },
            { col: '6', key: 'color', type: 'ColorInput', information: { label: '{{lang}}Color', disabled: false, required: true }, showMain: false, inExport: true },

            // { col: '12', type: 'SelectInput', key: 'parent', information: { label: '{{lang}}parent', updateAfterSelect: true, isSearchable: true, address: 'getAllCategory', filter: { page: 'form' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}placeholders.insertCategories', required: false }, showMain: false },
            { col: '12', key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: true }, showMain: true },
        ],

    },
    // users: {
    //     key: 'users',
    //     title: 'لیست کاربران',
    //     description: 'لیست کاربران',
    //     fetchUrl: 'employeeGetAll',
    //     addUrl: 'employeeAdd',
    //     editUrl: 'employeeAdd',
    //     removeUrl: 'employeeRemove',
    //     options: { noAddNew: true },
    //     // helperKey: 'values',
    //     pageType: 'form',
    //     parent: 'whthoutParent',
    //     options: {},
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //         unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
    //         block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
    //         terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
    //         remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
    //     },
    //     // sort: { 'cDate': -1 },
    //     // addNew: -1,
    //     image: '/images/icons/users.png',
    //     // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
    //     headers: [
    //         { col: '6', key: 'username', type: 'TextInput', information: { label: '{{lang}}Username', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'phone', type: 'TextInput', information: { label: '{{lang}}Phone number', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'email', type: 'TextInput', information: { label: '{{lang}}Email', disabled: false, required: true }, showMain: true, inExport: true },
    //         { col: '6', key: 'password', type: 'TextInput', information: { label: '{{lang}}Password', disabled: false }, showMain: false, inExport: true },
    //         { col: '6', key: 'personnelCode', type: 'TextInput', information: { label: 'کد پرسنلی', disabled: false }, showMain: false, inExport: true },

    //         { type: 'MultiSelectInput', key: 'jobs', col: '12', information: { label: 'شغل ها', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getJobs', filter: {} }, settings: { required: true }, showMain: true },

    //     ],

    // },

    importConsumption: {
        key: 'importConsumption',
        title: 'ایمپورت مصارف',
        description: 'ایمپورت مصارف',
        fetchUrl: 'getAllCategory',
        addUrl: 'categoryAdd',
        editUrl: 'categoryAdd',
        removeUrl: 'removeCategory',
        options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'operation',
        options: {},
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/icons/database.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '12', key: 'files', type: 'FileInput', information: { label: 'فایل', single: false, placeholder: '{{lang}}attachments', required: false }, showMain: false },
        ],

    },

}


export { energyPages, energySections }